import client from '../httpClient';

const divisionsGetDetailApi = (divisionId) => {
  return client.get(`/divisions/detail/${divisionId}`);
};

export default divisionsGetDetailApi;
